import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getScreenName, getVideoThumbnail } from '../../../Utils/helper';
import {
  ReviewsOnVideos,
  ThumbnailContainer,
  VideoCaption,
  VideoDuration,
  VideoStar,
} from './styled';

import { images } from '../../../Constants/ImageUrls';
import PlayIcon from './PlayIcon';
import { fireClickedCategoryCardEvent } from '../../CategoryL2Page/utils';
import { fireEvent } from '../../../Utils/fireEvent';

const VideoReviewPopup = dynamic(() => import('./VideoReviewPopup'), {
  ssr: false,
});

export default function VideoThumnail(props) {
  let {
    videoData,
    aplus,
    itemId,
    productData,
    index,
    allReviews,
    motherTrust,
    category,
    imageRatioDesktop,
    imageRatioMobile,
    categoryVideoData,
    resultNew,
    wrapperClass,
    increaseRatio,
  } = props;
  const router = useRouter();
  const paramsAdd = 'video';
  const videoCaption = videoData?.content?.title;
  const videoRating = videoData?.rating;
  const videoDuration = videoData?.content?.duration;
  const [showPopup, setShowPopup] = useState(false);
  const [focusElement, setFocusElement] = useState('');
  const videoUrl = videoData?.content?.url || videoData?.videoUrl;
  const thumbnailImage =
    videoData?.thumbnailImage || getVideoThumbnail(videoUrl);
  const videoOpenHandler = () => {
    setFocusElement('lowOpacity');
    setTimeout(() => {
      setShowPopup(true);
      const params = new URLSearchParams(window.location.search);
      params.set(paramsAdd, 'true');
      router.push(window?.location?.pathname + '?' + params, undefined, {
        shallow: true,
        scroll: false,
      });
      if (categoryVideoData) {
        fireClickedCategoryCardEvent(categoryVideoData);
      } else
        fireEvent({
          category: 'clicked_card_in_pdp',
          id: productData?.id,
          screen_name: getScreenName(),
          sku_name: productData?.name,
          selling_price: productData?.price,
          pdp_variant: aplus ? 'aplus' : 'aplusplus',
          sku_nickname: productData?.nickname,
          section_name: 'Video Reviews',
          card_id: videoData?.content?.id,
          position: index,
        });
      setFocusElement('');
    }, 50);
  };
  useEffect(() => {
    if (showPopup) {
      document.body.classList.add('noScroll');
    } else {
      document.body.classList.remove('noScroll');
    }
  }, [showPopup]);
  return (
    <>
      <ThumbnailContainer
        aplus={aplus}
        id={itemId}
        onClick={videoOpenHandler}
        allReviews={allReviews}
        motherTrust={motherTrust}
        category={category}
        className={`thumb ${wrapperClass || ''}`}
        resultNew={resultNew}
      >
        <div className="thumbDiv">
          <Image
            src={thumbnailImage}
            alt={productData?.name}
            className={`${focusElement} thumb_img`}
            loading="lazy"
            quality={90}
            fill
            sizes="33vw"
          />
          <PlayIcon allReviews={allReviews} />
          {videoDuration && (
            <VideoDuration allReviews={allReviews}>
              {videoDuration}
            </VideoDuration>
          )}

          {videoRating && (
            <ReviewsOnVideos allReviews={allReviews}>
              {Array.from(new Array(5).keys())?.map((index) => (
                <VideoStar
                  key={`ratingstars${index}`}
                  src={
                    videoRating >= index + 1
                      ? images.videoFilledStar
                      : videoRating > index == 0
                        ? images.videoEmptyStar
                        : images.videoHalfFilledStar
                  }
                  alt="ratingstar"
                />
              ))}
            </ReviewsOnVideos>
          )}
        </div>
        {videoCaption && (
          <VideoCaption allReviews={allReviews}>{videoCaption}</VideoCaption>
        )}
      </ThumbnailContainer>
      <VideoReviewPopup
        videoData={videoData}
        autoPlay={1}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        paramsAdd={paramsAdd}
        product={productData}
        videoUrl={videoUrl}
        parent={'video_review'}
        increaseRatio={increaseRatio}
      />
    </>
  );
}
